import { formatDisplayPrice } from '@vendasta/shared';
import { ProductPricing } from './pricing-details-dialog.component';

export class PricingDetailsDialogService {
  static getTotalCalculation(pricingInfo: ProductPricing[], state: string): string[] {
    return pricingInfo
      .map((productPricing) =>
        productPricing.pricingDetail.reduce((sum, item) => {
          const price = item.pricingFunc(state) || 0;
          return price < 0 || sum < 0 ? -1 : sum + price;
        }, 0),
      )
      .map((sumPrice) => formatDisplayPrice(sumPrice, 'USD'));
  }
}
